
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Couplefriendlypginhinjewadiphasenear() {



    const cardData =
    {
        keyword: 'Couple Friendly PG in Hinjewadi Phase 2 Near Wipro ',
        heading: 'Shree Swami Samarth PG: Couple Friendly PG in Hinjewadi Phase 2 Near Wipro',
        headingDescription: 'Shree Swami Samarth PG offers safe and comfortable couple-friendly PG in Hinjewadi Phase 2 near Wipro, providing a homely living experience for working couples and professionals. Our PG rooms are well-furnished, spacious, and designed to ensure privacy, with modern amenities like cozy bedding, wardrobes, study/work areas, and proper ventilation for a stress-free stay. Located just minutes away from Wipro and other leading IT companies, our PG ensures hassle-free daily commutes and excellent connectivity to major corporate hubs, shopping centers, and lifestyle amenities. Residents enjoy hygienic home-cooked meals, high-speed WiFi, 24x7 water supply, CCTV surveillance, and regular housekeeping, ensuring both safety and convenience. With disciplined management, affordable rent packages, and a peaceful environment, Shree Swami Samarth PG in Hinjewadi Phase 2 is the ideal choice for couples seeking reliable, secure, and comfortable accommodation near their workplace.',

        top: 'Top Facilities at Shree Swami Samarth PG ',

"topFacilities": [
  {
    "title": "Private Couple-Friendly Rooms",
    "description": "These PGs offer private rooms ideal for couples, designed with thoughtful layouts that ensure comfort and privacy. Rooms typically include a double bed, wardrobe, study desk, and may feature attached bathrooms or balconies. Spacious, well-lit interiors add a touch of homely sophistication, making the stay peaceful after long workdays. The design focus is on elegance and utility—perfect for couples seeking both functionality and aesthetics in their living space."
  },
  {
    "title": "Meals Included with Hygiene",
    "description": "Many couple-friendly PGs in Phase 2 include freshly prepared, hygienic meals—breakfast, lunch, and dinner—as part of the rent. Kitchens maintain strict cleanliness protocols, serving balanced, nutritious menus. This setup saves time and offers convenience for working couples, letting them enjoy wholesome home-style meals without daily cooking."
  },
  {
    "title": "High-Speed Wi-Fi & Work-from-Home Support",
    "description": "These PGs cater to modern working lifestyles by providing reliable high-speed Wi-Fi across rooms and common areas. Many have designated work zones or study corners equipped with proper lighting and charging outlets. Complemented by power backup, the setup ensures that remote work sessions, virtual meetings, and project deadlines remain uninterrupted—perfect for tech-savvy couples in the IT sector."
  },
  {
    "title": "Secure & Couple-Accommodative Premises",
    "description": "Security is prioritized with features like CCTV surveillance, controlled access, visitor screening, and friendly staff. Many PGs are gated or within secure complexes, adding an extra layer of safety. The couple-friendly policies ensure privacy and comfort while maintaining a respectful environment. This makes the property suitable and reassuring for both individuals and families."
  },
  {
    "title": "Convenient Location Near Wipro & Hinjewadi Hub",
    "description": "Located near Wipro and surrounded by Phase 2 commercial hubs, these PGs offer significantly reduced commute times. The strategic location also places residents close to retail outlets, supermarkets, cafés, gyms, and regular transport, enhancing convenience and supporting a balanced urban lifestyle for busy working professionals."
  },
  {
    "title": "Housekeeping & Laundry Services",
    "description": "Daily or regular housekeeping keeps rooms and shared areas clean, while laundry facilities—on-site or through partners—ensure clothes are cared for without hassle. These services save busy couples time, allowing them to focus on work, personal activities, or relaxation instead of daily chores."
  },
  {
    "title": "Recreation & Shared Social Spaces",
    "description": "Beyond private rooms, many PGs offer shared lounges, TV zones, and indoor games to help residents unwind and socialize. Some properties also organize community events or have small wellness corners. These amenities help foster a sense of community, making it easier for couples new to the city to settle in and feel connected."
  },
  {
    "title": "Transparent & Affordable Pricing",
    "description": "Couple-friendly PGs in Hinjewadi Phase 2 offer clear pricing with rent packages typically ranging between ₹ 7,000–₹ 15,000/month depending on amenities. Most packages include meals, Wi-Fi, housekeeping, and security. With no hidden costs, these accommodations offer excellent value—ideal for working couples seeking privacy, convenience, and peace of mind."
  }
],


"services": [
  {
    "name": "Couple Friendly PG in Hinjewadi Phase 2",
    "description": "Shree Swami Samarth PG offers safe and comfortable couple-friendly PG accommodations in Hinjewadi Phase 2. Designed specifically for married or working couples, our PGs provide privacy, security, and a homely environment with fully furnished rooms, attached bathrooms, and 24/7 security monitoring."
  },
  {
    "name": "PG for Couples Near Wipro Hinjewadi",
    "description": "Located near Wipro in Hinjewadi, our couple PGs offer convenient access to major IT offices. With dedicated spaces for couples, we ensure spacious rooms, hygienic food options, reliable housekeeping, and essential amenities tailored to meet the needs of working couples."
  },
  {
    "name": "Co-Living Spaces for Couples in Hinjewadi",
    "description": "Experience the best co-living spaces designed for couples at Shree Swami Samarth PG. Our community-focused environment encourages a comfortable lifestyle with shared common areas, Wi-Fi connectivity, recreational zones, and safe surroundings perfect for young professionals living together."
  },
  {
    "name": "PG Near Wipro Phase 2 for Married Couples",
    "description": "Our PG accommodations near Wipro Phase 2 in Hinjewadi are ideal for married couples looking for a peaceful stay with privacy and modern amenities. Enjoy secure entry, well-maintained rooms, nutritious meals, and easy connectivity to offices, markets, and transport hubs."
  },
  {
    "name": "Couple PG with Food in Hinjewadi",
    "description": "Shree Swami Samarth PG provides couple-friendly PGs with food services in Hinjewadi. Choose from vegetarian and non-vegetarian meal plans prepared hygienically every day, ensuring couples enjoy a balanced diet without the hassle of cooking, complemented by comfortable living spaces."
  },
  {
    "name": "Safe Couple PG Near IT Park Hinjewadi",
    "description": "Safety is our priority at Shree Swami Samarth PG. Our couple PG near Hinjewadi IT Park features CCTV surveillance, security guards, fire safety measures, and women-friendly policies to offer couples a secure and worry-free stay, allowing them to focus on their work and personal life."
  },
  {
    "name": "Luxury PG for Couples Near Wipro",
    "description": "Indulge in luxury living with our premium couple PG options near Wipro Hinjewadi. Fully furnished AC rooms, elegant interiors, high-speed internet, daily housekeeping, and exclusive recreational amenities make this the preferred choice for working couples seeking upscale accommodations."
  },
  {
    "name": "PG for Working Couples in Hinjewadi Phase 2",
    "description": "Tailored specifically for working couples, Shree Swami Samarth PG in Hinjewadi Phase 2 offers flexible rent plans, ergonomic furniture, uninterrupted Wi-Fi, power backup, and easy commute options. We ensure a supportive environment that balances professional commitments with personal comfort."
  }
],
"tableData": [
  ["Couple Friendly PG in Hinjewadi Phase 2", "PG for Couples Near Wipro Hinjewadi"],
  ["Co-Living Spaces for Couples in Hinjewadi", "PG Near Wipro Phase 2 for Married Couples"],
  ["Couple PG with Food in Hinjewadi", "Safe Couple PG Near IT Park Hinjewadi"],
  ["Luxury PG for Couples Near Wipro", "PG for Working Couples in Hinjewadi Phase 2"]
],




"whychoose": [
    {
        "WhyChooseheading": "Couple Friendly PG in Hinjewadi Phase 2 Near Wipro",
        "WhyChoosedescription": "Shree Swami Samarth PG offers comfortable, couple-friendly accommodations near Wipro in Hinjewadi Phase 2. Designed specifically to meet the needs of working couples, our PG combines privacy, security, and convenient access to major IT hubs."
    },
    {
        "WhyChooseheading": "Strategic Location Close to Wipro and IT Parks",
        "WhyChoosedescription": "Situated just minutes from Wipro and other major IT companies, our PG significantly reduces your daily commute, giving you more quality time to spend together or relax after work."
    },
    {
        "WhyChooseheading": "Spacious Rooms with Privacy for Couples",
        "WhyChoosedescription": "Our rooms for couples come fully furnished with queen-size beds, wardrobes, study desks, and attached bathrooms. The design ensures privacy while offering a cozy, homely environment for couples to unwind comfortably."
    },
    {
        "WhyChooseheading": "Inclusive Meals Prepared with Care",
        "WhyChoosedescription": "Enjoy fresh, hygienically prepared vegetarian and non-vegetarian meals served thrice daily. We cater to dietary preferences and provide balanced, nutritious food to keep you energized throughout the day."
    },
    {
        "WhyChooseheading": "Safe, Secure, and Respectful Environment",
        "WhyChoosedescription": "Our couple-friendly PG prioritizes your safety with 24/7 CCTV surveillance, biometric entry, and respectful staff. The premises maintain a peaceful atmosphere suitable for working couples balancing career and personal life."
    },
    {
        "WhyChooseheading": "All-Inclusive Rent with Transparent Pricing",
        "WhyChoosedescription": "Our rent packages cover everything—from accommodation, food, electricity, Wi-Fi, to housekeeping—without any hidden fees or brokerage. Flexible lease terms make it easy to choose what suits your stay duration."
    },
    {
        "WhyChooseheading": "Convenient Amenities for a Comfortable Stay",
        "WhyChoosedescription": "With high-speed internet, power backup, laundry services, and daily cleaning, our PG ensures you have all essential amenities at your fingertips to enjoy a hassle-free and comfortable lifestyle."
    },
    {
        "WhyChooseheading": "Ideal for Working Couples Seeking Quality Living",
        "WhyChoosedescription": "Whether you’re both IT professionals, interns, or remote workers, our PG creates the perfect balance between work and personal life, offering a serene and supportive environment to thrive together."
    }
]























    }
    
const faqData = [
    {
        question: "How can I book a couple-friendly PG in Hinjewadi Phase 2 near Wipro?",
        answer: "To book a couple-friendly PG near Wipro in Phase 2, simply call us at +91 9594917913. We also offer assistance with online booking and property visits."
    },
    {
        question: "Is your PG in Hinjewadi Phase 2 suitable for couples?",
        answer: "Yes, we provide well-maintained, couple-friendly rooms with complete privacy, comfort, and modern amenities for live-in working professionals."
    },
    {
        question: "What type of rooms are offered for couples in your PG?",
        answer: "We offer fully furnished private rooms with attached bathrooms, A/C options, double beds, Wi-Fi, and storage space for couples."
    },
    {
        question: "Is food included in your couple PG package?",
        answer: "Yes, we serve freshly cooked, hygienic vegetarian meals—breakfast, lunch, and dinner—all included in the monthly rent."
    },
    {
        question: "How close is your PG to Wipro in Hinjewadi Phase 2?",
        answer: "Our PG is just 5–10 minutes from the Wipro campus in Phase 2, making it ideal for couples working in or around the tech park."
    },
    {
        question: "Is your PG safe and secure for couples?",
        answer: "Absolutely. We maintain 24/7 CCTV surveillance, biometric entry, professional in-house staff, and dedicated privacy policies for couples."
    },
    {
        question: "Do you allow unmarried couples to stay at the PG?",
        answer: "Yes, we welcome both married and unmarried couples with valid ID proof, subject to basic verification and terms of stay."
    },
    {
        question: "Are there any restrictions for couples staying at your PG?",
        answer: "No unnecessary restrictions. We promote a peaceful, respectful environment and expect the same from all residents."
    },
    {
        question: "What is the rent for a couple-friendly PG room near Wipro?",
        answer: "Rent varies depending on A/C preferences and room size. Contact us directly for the most accurate and current pricing."
    },
    {
        question: "How do I schedule a visit or book the couple PG in Hinjewadi Phase 2?",
        answer: "Call us anytime at +91 9594917913 to check availability, schedule a viewing, or confirm your booking."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Nikhil More',
        designation: 'Software Engineer, Wipro Hinjewadi Phase 2',
        rating: [1, 1, 1, 1, 1],
        text: '“The couple PG at Shree Swami Samarth was perfect for us. Spacious room, great food, no interference, and just 10 minutes from Wipro.”',
    },
    {
        name: 'Ms. Tanvi Desai',
        designation: 'Data Analyst, Infosys Hinjewadi',
        rating: [1, 1, 1, 1, 1],
        text: '“Safe, peaceful, and respectful atmosphere for couples. We really liked the location and the staff was always helpful. Highly recommended!”',
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9209169761",
            "+91 9096665072",

        ],
        email: "reservation@swamisamarthpg.com "
    };


     const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " PG in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "  Single Room PG in Pune",
        },
        
        {
            place: "/images/keyword/4.jpg",
            text: "  Best Luxury PG in Pune",
        },
       
       
        {
            place: "/images/keyword/13.jpg",
            text: "  Hostel in Pune",
        },

        {
            place: "/images/keyword/15.jpg",
            text: " PG for Working Professionals Pune",
        },
        
        {
            place: "/images/keyword/19.jpg",
            text: "  Paying Guest Near Hinjewadi IT Park Pune",
        },
        

    ];


    const images = [
        { src: "./images/gallery/1.jpg", alt: "Image 1" },
        { src: "./images/gallery/2.jpg", alt: "Image 1" },
        { src: "./images/gallery/3.jpg", alt: "Image 1" },
        { src: "./images/gallery/4.jpg", alt: "Image 1" },
        { src: "./images/gallery/5.jpg", alt: "Image 1" },
        { src: "./images/gallery/6.jpg", alt: "Image 1" },
        { src: "./images/gallery/7.jpg", alt: "Image 1" },
        { src: "./images/gallery/8.jpg", alt: "Image 1" },
        { src: "./images/gallery/9.jpg", alt: "Image 1" },

    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Couple Friendly PG in Hinjewadi Phase 2 Near Wipro",
  "image": "https://swamisamarthpg.com/assets/images/couple-friendly-pg-hinjewadi-phase2.jpg", // Replace with actual image URL
  "description": "Safe and comfortable couple friendly PG accommodations in Hinjewadi Phase 2 near Wipro. Ideal co-living spaces for working couples with food facilities and premium amenities.",
  "brand": {
    "@type": "Brand",
    "name": "Shree Swami Samarth PG"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.92",
    "ratingCount": "1700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "11000",  // Replace with actual price if needed
    "availability": "https://schema.org/InStock",
    "url": "https://swamisamarthpg.com/couple-friendly-pg-hinjewadi-phase2-wipro"  // Replace with actual page URL if different
  }
};





    return (
        <div>

<Helmet>
  <title>Couple Friendly PG in Hinjewadi Phase 2 Near Wipro | Safe & Comfortable</title>
  <meta 
    name="description" 
    content="Safe and comfortable couple friendly PG near Wipro in Hinjewadi Phase 2. Perfect for working couples with food facilities and premium amenities." 
  />
  <meta 
    name="keywords" 
    content="Couple Friendly PG in Hinjewadi Phase 2, PG for Couples Near Wipro Hinjewadi, Co-Living Spaces for Couples in Hinjewadi, PG Near Wipro Phase 2 for Married Couples, Couple PG with Food in Hinjewadi, Safe Couple PG Near IT Park Hinjewadi, Luxury PG for Couples Near Wipro, PG for Working Couples in Hinjewadi Phase 2" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF6403', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topFacilities.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                          

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Shree Swami Samarth PG</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                {/* <FAQKeyword faqs={faqData} /> */}
                <Accordion data={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF6403',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF6403' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919209169761" className="d-block  text-white">+91 9209169761</a>
                                                <a href="tel:+919096665072" className="d-block  text-white">+91 9096665072</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:reservation@swamisamarthpg.com " className=" text-white d-block">
                                                    reservation@swamisamarthpg.com 
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF6403' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Shree Swami Samarth PG  <br />
                                                        M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Couplefriendlypginhinjewadiphasenear;